import {Route, Routes} from "react-router-dom";
import {PromptManagementCreate, PromptManagementDetail, PromptManagementList} from "./pages";
import {Provider} from "mobx-react";
import {PromptManagementStoreInstance} from "./store";

export const PromptManagementSystemPage = () => {
  return (
    <Provider store={PromptManagementStoreInstance}>
      <Routes>
        <Route index element={<PromptManagementList />} />
        <Route path="/create" element={<PromptManagementCreate />} />
        <Route path="/:id" element={<PromptManagementDetail />} />
      </Routes>
    </Provider>
  );
}

export default PromptManagementSystemPage;
